import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { GET_CLIENT, GET_TASKS } from '../queries';
import { useV2Query } from 'utils';
import { JobType, TaskStatus } from '../types';
import { colors } from 'bench-style-constants';

const NotificationWrapper = styled.div`
  background-color: ${colors.copper};
  border-radius: 4px;
  color: ${colors.white};
  padding: 0 8px;
  margin-right: 8px;

  &:hover {
    color: ${colors.white};
  }
`;

const jobTypesToIncludeInNotifications = [
  JobType.RESOLVE_BALANCE_CHECKER,
  JobType.RESOLVE_PLAID_CONNECTION,
];

const TaskNotification = ({ clientId }: { clientId: string }) => {
  const { push } = useHistory();
  const { data } = useV2Query(GET_CLIENT, { variables: { clientId } });
  const personId = data?.client?.delegatedBookkeeper?.id;

  const { data: tasksData } = useV2Query(GET_TASKS, {
    variables: {
      filterBy: {
        clientIds: [clientId],
        assignedPersonId: personId ? parseInt(personId) : undefined,
        status: TaskStatus.PENDING_WORK,
        jobTypes: jobTypesToIncludeInNotifications,
      },
    },
    skip: !personId,
  });

  const tasksCount = tasksData?.tasks.tasks.length;

  if (!personId || !tasksCount) return <></>;
  return (
    <NotificationWrapper onClick={() => push('/task-manager')}>{tasksCount}</NotificationWrapper>
  );
};

export default TaskNotification;
